import { render, staticRenderFns } from "./MaterialBind.vue?vue&type=template&id=52c15775&scoped=true&"
import script from "./MaterialBind.vue?vue&type=script&lang=js&"
export * from "./MaterialBind.vue?vue&type=script&lang=js&"
import style0 from "./MaterialBind.vue?vue&type=style&index=0&id=52c15775&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c15775",
  null
  
)

export default component.exports